import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overview_dashboard py-3" }
const _hoisted_2 = { class: "d-flex w-100 justify-content-between align-items-center" }
const _hoisted_3 = { class: "fw-bold mb-0" }
const _hoisted_4 = { class: "card border-0 mt-3" }
const _hoisted_5 = { class: "p-d-flex p-d-flex-wrap p-jc-between" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h6", { class: "p-text-center" }, "No User found.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", { class: "p-text-center" }, "Loading User data. Please wait.", -1)
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "d-flex justify-content-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you sure you want to proceed ?")
], -1)
const _hoisted_11 = { class: "confirmation-content" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-center py-5" }, "No partnership declaration found!...", -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createVNode(_component_DataTable, {
        responsiveLayout: "scroll",
        breakpoint: "700px",
        value: _ctx.getUsers,
        paginator: true,
        loading: _ctx.loading,
        rows: 10,
        columnResizeMode: "fit",
        selection: _ctx.selectedUsers,
        "onUpdate:selection": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedUsers) = $event)),
        scrollHeight: "flex",
        globalFilterFields: ['user_type'],
        filters: _ctx.filters,
        "onUpdate:filters": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters) = $event)),
        filterDisplay: "menu"
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Dropdown, {
              class: "p-dropdown-sm py-0",
              modelValue: _ctx.userTypeFilter,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userTypeFilter) = $event)),
              options: _ctx.userType,
              optionLabel: "name",
              optionValue: "name",
              placeholder: "User Type"
            }, null, 8, ["modelValue", "options"]),
            _createVNode(_component_Button, {
              label: "Invite Program Coordinator",
              icon: "pi pi-plus-circle",
              class: "p-button-raised mb-1 p-button-text",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.addProgramCoordinator()), ["prevent"])),
              "aria-label": "Add User"
            }),
            _withDirectives(_createVNode(_component_Button, {
              label: "Deactivate Users",
              icon: "pi pi-user-minus",
              iconPos: "right",
              class: "p-button-raised mb-1 p-button-danger",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.deleteUsers()), ["prevent"])),
              disabled: _ctx.selectedUsers?.length <= 0,
              "aria-label": "Deactivate User"
            }, null, 8, ["disabled"]), [
              [
                _directive_tooltip,
                'Deactivate, selected users',
                void 0,
                { top: true }
              ]
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _hoisted_6
        ]),
        loading: _withCtx(() => [
          _hoisted_7
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            selectionMode: "multiple",
            headerStyle: "width: 3em"
          }),
          _createVNode(_component_Column, {
            header: "Name",
            sortable: true,
            frozen: true
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.first_name + ", " + slotProps.data.last_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "type",
            header: "User-Type",
            sortable: true,
            frozen: false
          }),
          _createVNode(_component_Column, {
            field: "email",
            header: "Email Address",
            sortable: true,
            frozen: false
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("a", {
                href: `mailto:${slotProps.data.email}?subject=BHMIS`,
                class: "text-dark"
              }, _toDisplayString(_ctx.trimText(slotProps.data.email, 25)), 9, _hoisted_8)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            exportable: false,
            header: "",
            style: {"min-width":"4rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("div", _hoisted_9, [
                (slotProps.data.type === 'PARTNERS')
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "",
                      icon: "pi pi-file",
                      class: "p-button-sm mb-1 p-button-text text-dark",
                      onClick: ($event: any) => (_ctx.getDeclaration(slotProps.data)),
                      "aria-label": "View Details"
                    }, null, 8, ["onClick"])), [
                      [
                        _directive_tooltip,
                        `View Declaration`,
                        void 0,
                        { left: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_Button, {
                  label: "",
                  icon: "pi pi-user",
                  class: "p-button-sm mb-1 p-button-text text-dark",
                  onClick: ($event: any) => (_ctx.getUserProfile(slotProps.data)),
                  "aria-label": "View Details"
                }, null, 8, ["onClick"]), [
                  [
                    _directive_tooltip,
                    `View ${slotProps.data.first_name}, profile`,
                    void 0,
                    { left: true }
                  ]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "selection", "filters"])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.inviteDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inviteDialog) = $event)),
      style: { width: '40rem' },
      header: _ctx.title,
      modal: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Form, { onClose: _ctx.closeInviteDialog }, null, 8, ["onClose"])
      ]),
      _: 1
    }, 8, ["visible", "header"]),
    _createVNode(_component_Dialog, {
      header: _ctx.deleteUserData?.first_name + ', ' + _ctx.deleteUserData?.last_name,
      visible: _ctx.displayConfirmation,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.displayConfirmation) = $event)),
      style: { width: '30rem' },
      modal: true
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.displayConfirmation = false)),
          class: "p-button-raised p-button-text",
          "aria-label": "NO"
        }),
        _createVNode(_component_Button, {
          label: "Delete",
          icon: "pi pi-trash",
          class: "p-button-raised p-button-danger p-button-text p-text-danger",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.deleteUser())),
          "aria-label": "Delete"
        })
      ]),
      default: _withCtx(() => [
        _hoisted_10
      ]),
      _: 1
    }, 8, ["header", "visible"]),
    _createVNode(_component_Dialog, {
      header: 'Partnership Declarations',
      visible: _ctx.partnershipsModal,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.partnershipsModal) = $event)),
      style: { width: '30rem' },
      modal: true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DataTable, {
            responsiveLayout: "scroll",
            breakpoint: "700px",
            value: _ctx.getPartnershipDeclarations,
            paginator: true,
            loading: _ctx.loading,
            rows: 10,
            columnResizeMode: "fit",
            selection: _ctx.selectedUsers,
            "onUpdate:selection": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedUsers) = $event)),
            scrollHeight: "flex",
            filterDisplay: "menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "innovation_name",
                header: "Innovation-Proposal"
              }),
              _createVNode(_component_Column, {
                field: "",
                header: ""
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    label: "",
                    icon: "pi pi-download",
                    onClick: ($event: any) => (_ctx.downloadForm(slotProps.data)),
                    class: "px-3"
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading", "selection"]),
          (_ctx.getPartnershipDeclarations?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}